import "./App.css";
import StartUp from "./components/StartUp/StartUp.js";
import Navbar from "./components/Navbar/Navbar.js";
import { Route, Routes } from "react-router-dom";
import ContactUs from "./components/ContactUs/ContactUs";
import { useEffect, useState } from "react";
import { requestForToken, onMessageListener } from "./components/firebase";
// import ReactNotificationComponent from "./components/NotificationsWebPage/ReactNotification";

function App() {
  const [isTokenFound, setTokenFound] = useState(false);
  console.log("Token Found", isTokenFound);
  const [show, setShow] = useState(false);
  const [notification, setNotification] = useState({
    title: "خدمات التنظيف السعودية",
    body: "",
  });

  console.log(show, notification);

  // onMessageListener();
  // .then((payload) => {
  //   setShow(true);
  //   setNotification({
  //     title: "خدمات التنظيف السعودية",
  //     body: payload.notification.body,
  //   });
  //   console.log(payload);
  // })
  // .catch((err) => console.log("failed: ", err));

  useEffect(() => {
    let data;
    async function tokenFunc() {
      data = await requestForToken(setTokenFound);
      if (data) {
        console.log("Token is", data);
      }
      return data;
    }
    tokenFunc();
  }, [setTokenFound]);
  return (
    <div className="App">
      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.9.1/font/bootstrap-icons.css"
      ></link>
      {/* {show ? (
        <ReactNotificationComponent
          title={notification.title}
          body={notification.body}
        />
      ) : (
        <></>
      )} */}

      <Routes>
        <Route path="/" element={<StartUp />} />
        <Route path="Navbar/*" element={<Navbar />} />
        <Route path="ContactUs/*" element={<ContactUs />} />
      </Routes>
    </div>
  );
}

export default App;
